import axios from "axios";
import { FETCH_ROLE_SUBS_FAILURE, FETCH_ROLE_SUBS_REQUEST, FETCH_ROLE_SUBS_SUCCESS, FETCH_ROLE_SUBS_SUCCESS_2, FETCH_ROLE_SUB_FAILURE, FETCH_ROLE_SUB_REQUEST, FETCH_ROLE_SUB_SUCCESS, FETCH_RESERVATION_FAILURE, FETCH_RESERVATION_REQUEST, FETCH_RESERVATION_SUCCESS } from "../../app/actions/actions";
import { ROUTES } from "../../config/routingUrl";
import { dureeDeVie, getAndCheckLocalStorage, setWithExpiration } from "../../utils/storage/localvalueFuction";
import { localStorageData, localStorageKeys } from "../../utils/storage/localvalue";
import { baseurl, checkWordInURL } from "../../utils/url/baseurl";
import { saveDataToFile } from "../DataLocal";
import { toast } from "react-toastify";






// All reservation of plateforme
export function fetchRoleSubsAll(type, label, name, description) {
    return async (dispatch) => {
        dispatch({ type: FETCH_ROLE_SUBS_REQUEST });

        const params = new URLSearchParams();
        if (type) params.append("type", type);
        if (label) params.append("label", label);
        if (name) params.append("name", name);
        if (description) params.append("description", description);

        await axios.get(`${baseurl.url}/api/v1/role_users/get_role_users?${params.toString()}`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `${baseurl.TypeToken} ${baseurl.token}`
            }
        })
            .then((response) => {
                //console.log(response.data.data);
                dispatch({ type: FETCH_ROLE_SUBS_SUCCESS, payload: response.data.data });
                dispatch({ type: FETCH_ROLE_SUBS_SUCCESS_2, payload: response.data.data });
                saveDataToFile(response.data.data, localStorageData.RoleSubs);
            })
            .catch((error) => {
                //console.log(error);
                dispatch({ type: FETCH_ROLE_SUBS_FAILURE, payload: error.message });
            });
    }
}



// get reservation by id 
export function fetchRoleSubById(idRoleSub) {
    return async (dispatch) => {
        dispatch({ type: FETCH_ROLE_SUB_REQUEST });
        await axios.get(`${baseurl.url}/api/v1/role_users/get_role_user/${idRoleSub}`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `${baseurl.TypeToken} ${baseurl.token}`
            }
        }).then((response) => {
            // console.log(response.data.data);
            dispatch({ type: FETCH_ROLE_SUB_SUCCESS, payload: response.data.data });
        })
            .catch((error) => {
                dispatch({ type: FETCH_ROLE_SUB_FAILURE, payload: error.message })
                //console.log(error);
            });
    }
}

